export default "https://lightningbookassetsdev.blob.core.windows.net/lightning-ui/1.46.0/ui/9135d9c2f4d92adc.png"